import { Component, Input } from '@builder.io/sdk';

import sectionFields from 'molecules/Section/config';

const socialShareFields = [
  {
    name: 'label',
    type: 'string',
    defaultValue: 'Share this post',
    helperText: 'Text title to be displayed.',
  },
  ...sectionFields,
] as const satisfies DeepReadonly<Input[]>;

const socialShareConfig = {
  name: 'socialShare',
  inputs: socialShareFields,
} as Component;

export type SocialShareConfigProps = GenerateBuilder<typeof socialShareFields>;
export default socialShareConfig;
